// Module
var code = "<ul> <li>[Career Planning]</li> <li>[Preparing for School]</li> <li>[Paying for School]</li> <li>[Self - Assessments]</li> <li>[Ask a Counselor]</li> <li>[My Smart Borrowing]</li> </ul> ";
// Exports
export default code;